import { atom } from 'jotai';

export enum DowngradeReconsiderModalVariant {
  Evidence = 'evidence',
  Clinician = 'clinician',
  Practice = 'practice',
}

export interface DowngradeReconsiderModalState {
  open: boolean;
  variant: DowngradeReconsiderModalVariant | null;
}

export const downgradeReconsiderModalStateAtom = atom<DowngradeReconsiderModalState>({
  open: false,
  variant: null,
});
